import { useModalMeta } from "@/shared/atoms/useModal";
import { useTranslation } from "react-i18next";
import Button from "../Button/Button";
import Modal, { ModalProps } from "../Modal/Modal";

const PosOrderChangeLabelModal = ({ onExit, ...props }: ModalProps) => {
  const { t } = useTranslation("");
  const [meta] = useModalMeta();
  const { customLabel } = meta;

  return (
    <Modal width="40rem" onExit={onExit} {...props}>
      {customLabel && <p>{customLabel}</p>}
      <div className="mt-12 flex justify-end gap-4">
        <Button variant="secondary" type="button" onClick={() => onExit()}>
          {t("close")}
        </Button>
      </div>
    </Modal>
  );
};

export default PosOrderChangeLabelModal;
